import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import AdNav from "../components/adNav";
import Time from "../components/time";

const Admin_Menu_add = () => {
     const [dept, setDept] = useState([]);
      const [subDept, setSubDept] = useState([]);
  const [formData, setFormData] = useState({ heading: "", desc: "", expiryDate: "", content: "" });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDept = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/adminMenu_Deptlist");
        setDept(response.data.dept);
      } catch (error) {
        console.error("Error fetching ListData:", error);
      }
    };
    fetchDept();
  }, []);
  
  useEffect(() => {
      const fetchSubDept = async () => {
        try {
          const response = await axios.get("https://rfs2.infraconsoft.net.in/api/adminMenu_subDeptlist");
          setSubDept (response.data.subDept);
        } catch (error) {
          console.error("Error fetching ListData:", error);
        }
      };
      fetchSubDept();
    }, []);
   

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
        title: formData.title,
        dept: formData.dept,
        subDept: formData.subDept,
        link : formData.link,
    };

    console.log(payload);
    

    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios.post("https://rfs2.infraconsoft.net.in/api/adminMenuList_insert", payload);

      Swal.fire("Success", "Menu List added successfully", "success");
      navigate("/admin/admin_Menu");
    } catch (error) {
      Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
  };

  return (
    <div id="admin-container">
      <AdNav />
      <div className="content-right">
        <section>
          
                      <div className="back-div">
                        <h2 className="add-txt">Admin Menu Add</h2>
                        <Link to='/admin/admin_Menu'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                        </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
          <div className="form-group">
                <label>Department :</label>
                <select name="dept"  value={formData.dept}  onChange={handleChange} >
            <option value="">Select Dept</option>
            {dept.map((item) => (
              <option key={item.department} value={item.department}>
                {item.department}
              </option>
            ))}
          </select>
              </div>
              <div className="form-group">
                <label>Sub Department :</label>
                <select name="subDept"  value={formData.subDept}  onChange={handleChange} >
            <option value="">Select Sub Department</option>
            {subDept.map((item) => (
              <option key={item.subdepartment} value={item.subdepartment}>
                {item.subdepartment}
              </option>
            ))}
          </select>
              </div>
            </div>

          <div className="form-row">
              <div className="form-group">
                <label>Title :</label>
                <input type="text" name="title" value={formData.title} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Link Page :</label>
                <input type="text" name="link" value={formData.link} onChange={handleChange} />
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Admin_Menu_add;
